/*
 * @Description:
 * @Author: doris_xu
 * @Date: 2025-06-09 15:41:45
 * @LastEditTime: 2025-06-09 17:37:35
 */
import React from 'react'
import Flower from '../../components/flower/flower'
import prizeBg from '../../images/prizeBg.png'

const PrizeInfo: React.FC = () => {
  return (
    <div
      className="home-full-row"
      style={{
        backgroundImage: `url(${prizeBg})`,
        backgroundRepeat: 'round',
        marginTop: '0px',
      }}>
      <div className="home-row" style={{ paddingTop: '64px' }}>
        <div className="glod-row">
          <Flower title={'专利运营\n潜力奖'} type={'gold'} />
          <Flower title={'专利\n产业化奖'} type={'gold'} />
          <Flower title={'专利\n许可转让奖'} type={'gold'} />
          <Flower title={'专利\n作价入股奖'} type={'gold'} />
          <Flower title={'专利运营\n机构贡献奖'} type={'gold'} />
          {/* <Flower title={'专利运营\n投资价值奖\n2万元'} type={'gold'} />
          <Flower title={'专利运营\n成长价值奖\n2万元'} type={'gold'} />
          <Flower title={'专利运营\n潜力价值奖\n2万元'} type={'gold'} />
          <Flower title={'专利运营\n优秀奖\n5000元'} type={'gold'} /> */}
        </div>
      </div>
      <div
        className="home-row"
        style={{ marginTop: '60px', paddingBottom: '64px' }}>
        <div className="activity-div-subTitleContainer ">
          <div className="titleContainer-div-separator"></div>
          <Flower title={'2025上高赛\n项目价值榜'} type={'blue'} />
          <Flower title={'2025上高赛\n机构服务榜'} type={'blue'} />
          <div className="titleContainer-div-separator"></div>
        </div>
      </div>
    </div>
  )
}

export default PrizeInfo
